module.exports = __webpack_public_path__ + "img/meneath_titre_en.57d0d10d.png";